'use strict';exports.__esModule = true;var _moment = require('moment');var _moment2 = _interopRequireDefault(_moment);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var checkIsRocketPromoted = function checkIsRocketPromoted(property) {var
  isRocketPromoted = property.is_rocket_promoted,rocketValidUntil = property.rocket_valid_until;
  var now = (0, _moment2.default)();
  var expirationDate = (0, _moment2.default)(rocketValidUntil);
  var isRocketDateValid = expirationDate.isAfter(now);
  return isRocketPromoted || !!rocketValidUntil && isRocketDateValid;
};exports.default =

checkIsRocketPromoted;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PropertiesTable/helpers.js
// module id = 573
// module chunks = 0